/* Native Shopify commerce enhancement. Forms retain normal server fallbacks. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const announce = (message) => {
    const notice = document.querySelector('.native-cart-notice');
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = false;
    clearTimeout(notice.dismissTimer);
    notice.dismissTimer = setTimeout(() => { notice.hidden = true; }, 6000);
  };
  function setupProduct(scope) {
    if (scope.dataset.initialized) return;
    scope.dataset.initialized = 'true';
    const variants = JSON.parse(scope.querySelector('[data-native-variants]')?.textContent || '[]');
    const form = scope.querySelector('[data-native-product-form]');
    if (!form) return;
    const variantSelect = form.querySelector('[name="id"]');
    const planSelect = form.querySelector('[data-selling-plan]');
    const button = form.querySelector('[name="add"]');
    const quantity = form.querySelector('[data-native-quantity]');
    const status = form.querySelector('[data-form-status]');
    const update = (scrollImage = false, resetQuantity = false) => {
      const variant = variants.find(v => String(v.id) === variantSelect.value);
      if (!variant) return;
      if (planSelect) {
        for (const option of planSelect.options) {
          option.disabled = !!option.value && !variant.allocations.some(p => String(p.id) === option.value);
        }
        if (planSelect.selectedOptions[0]?.disabled) {
          const firstEnabled = [...planSelect.options].find(o => !o.disabled);
          if (firstEnabled) planSelect.value = firstEnabled.value;
        }
      }
      const plan = variant.allocations.find(p => String(p.id) === planSelect?.value);
      const price = scope.querySelector('[data-variant-price]');
      price.textContent = plan?.price || variant.price;
      if (variant.onSale && !plan) {
        const compare = document.createElement('s');
        compare.textContent = variant.compare;
        price.append(' ', compare);
      }
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      quantity.min = variant.min;
      quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max');
      else quantity.max = variant.max;
      if (resetQuantity || !quantity.value) quantity.value = variant.min;
      if (scrollImage && variant.imageId) scope.querySelector(`#media-${variant.imageId}`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    variantSelect.addEventListener('change', () => update(true, true));
    planSelect?.addEventListener('change', () => update());
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = 'ADDING…';
      status.textContent = '';
      status.setAttribute('role', 'status');
      try {
        const data = new FormData(form);
        if (!data.get('selling_plan')) data.delete('selling_plan');
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).catch(() => null);
        if (cartResponse?.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.native-cart-count').forEach(el => { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
        }
        status.replaceChildren(document.createTextNode('Added to cart. '));
        const link = document.createElement('a');
        link.href = root + 'cart';
        link.textContent = 'View cart and checkout';
        status.append(link);
        announce('Added to cart');
      } catch (error) {
        status.textContent = error.message;
        status.setAttribute('role', 'alert');
      } finally {
        const variant = variants.find(v => String(v.id) === variantSelect.value);
        button.disabled = !variant?.available;
        button.textContent = variant?.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    });
  }
  const init = () => document.querySelectorAll('[data-native-product]').forEach(setupProduct);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  // Homepage knowledge-search fields originally belonged to a third-party app.
  // Search through Shopify's own search route instead.
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-native-search-input]') && !event.target.closest('form')) {
      event.preventDefault();
      const q = event.target.value.trim();
      if (q) location.href = root + 'search?q=' + encodeURIComponent(q);
    }
  });
  document.addEventListener('click', event => {
    const scope = event.target.closest('.kc-quick-search, .kc-quick-search-block');
    if (!scope || !event.target.closest('button')) return;
    const input = scope.querySelector('[data-native-search-input]');
    if (input?.value.trim()) location.href = root + 'search?q=' + encodeURIComponent(input.value.trim());
  });
})();
